module.exports = __webpack_public_path__ + "img/step-2.8316d23b.png";